import { db, storage, DEFAULT_CAMPAIGN_COLLECTION } from './firebase.js'

export const getData = (collection, {field, condition, value}) => {
    return db
        .collection(collection)
        .where(field, condition, value)
        .get()
}

export const getDataByDocId = ({collection, id}) => {
    return db
        .collection(collection)
        .doc(id)
        .get();
}

export const getRef = ({collection, id}) => {
    if(id) {
        return db.collection(collection).doc(id)
    }
    return db.collection(collection).doc()
}

export const updateData = ({id, data, collection}) => {
    return db
        .collection(collection)
        .doc(id)
        .update(data)
}

export const addData = ({collection, data}) => {
    return db
        .collection(collection)
        .add(data)
}

export const deleteData = ({collection, id}) => {
    return db.collection(collection)
        .doc(id)
        .delete()
}

export const uploadImage = async e => {
    const filename = `${new Date().getTime()}-${Math.floor(Math.random() * 1000)}-${e.name.toLowerCase().replace(/ /g, '-')}`
    const file = await storage
        .ref()
        .child(filename)
        .put(e);
    return file.ref.getDownloadURL();
}